<template>
  <vs-popup class="create-production-line-popup"
            title="CREATE PRODUCTION LINE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-production-line-popup" @submit.prevent="handleSubmit(onClickCreateProductionLine)" autocomplete="off">

             <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="production_line_name" name="production_line_name" rules="required" v-slot="{ errors }">
                  <small class="label">Production Line Name</small>
                  <vs-input v-model="createForm.production_line_name"  name="production_line_name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
               <div class="vx-col md:w-1/2 w-full md:mb-0">
                 <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                   <small class="label">Type</small>
                   <v-select  :clearable="true" name="type" placeholder="" v-model="createForm.type" :options="types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                   <span class="text-danger text-sm">{{ errors[0] }}</span>
                 </ValidationProvider>
               </div>
            </div>

            <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="max_capacity_ltr" name="max_capacity_ltr" rules="required" v-slot="{ errors }">
                  <small class="label">Max Capacity (L)</small>
                  <vs-input step="0.1" type="number" v-model="createForm.max_capacity_ltr"  name="max_capacity_ltr" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="max_capacity_kg" name="max_capacity_kg" rules="required" v-slot="{ errors }">
                  <small class="label">Max Capacity (KG)</small>
                  <vs-input step="0.1" type="number" v-model="createForm.max_capacity_kg"  name="max_capacity_kg" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

<!--          <div class="vx-row mb-3 mt-2">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider vid="clean_time_between_uses" name="clean_time_between_uses" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Clean Time Between Uses (Mins)</small>-->
<!--                <vs-input step="1" type="number" v-model="createForm.clean_time_between_uses"  name="clean_time_between_uses" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row mb-3 mt-2">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="clean_time_between_uses" name="clean_time_between_uses" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea v-model="createForm.description" height="100px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3 mt-2">
            <div class="vx-col md:w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea v-model="createForm.note" height="100px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

            <div class="flex flex-wrap items-center justify-end mt-8" >
              <vs-button id="save_change_button" button="submit" class="ml-auto mt-2">Save changes</vs-button>
              <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
            </div>

        </form>
      </ValidationObserver>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {},
      types: ['liquid', 'powder', 'fruit']
    }
  }

export default {
  name: 'CreateProductionLinePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateProductionLine (){
      const vue = this
      await this.$vs.loading({
        container: '#create-production-line-popup',
        scale: 0.45
      })
       try {
         await ManufacturingRepository.createProductionLine(this.createForm)
         this.showSuccessMessage('Production line create successfully')
         this.open = false;
         await vue.$parent.refreshData()
         this.$vs.loading.close('#create-production-line-popup > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#create-production-line-popup > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-production-line-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
